/* eslint-disable quotes */
import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PoliciesAndFaqs from './policies-and-faqs';

const PoliciesFaqs = () => {
    return (
        <Accordion className='bg-white border-border rounded-md mb-32 z-0' defaultExpanded={true} classes={{ root: 'shadow-none', expanded: 'mt-0 shadow-none' }} sx={{ border: 1 }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className='text-primary font-bold' />}
                aria-controls="panel1a-content"
                id="panel1a-header" className='z-0'
            >
                <Typography className='text-xl font-bold text-primary'>Policies FAQ</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <PoliciesAndFaqs />
            </AccordionDetails>
        </Accordion>
    );
};

export default PoliciesFaqs;
